import { cn } from '@/lib/utils';

/**
 * Logo "Baila.fm" — paths SVG portados desde apps/web (BailaLogo).
 * Usa `currentColor` para que el color se controle vía utilities
 * de Tailwind (`text-foreground`, `text-black`, etc.) en el padre.
 */

interface BailaLogoProps {
  className?: string;
  width?: number;
  height?: number;
}

export function BailaLogo({ className, width = 125, height = 24 }: BailaLogoProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 125 24"
      fill="none"
      aria-label="Baila.fm"
      role="img"
      className={cn('block', className)}
    >
      <path
        d="M5.46068 24L23.939 17.3077V11.3751L18.0246 9.15356V8.17442L23.939 5.91546V0L6.58747 0.0438709L0 18.5051L5.46068 24Z"
        fill="currentColor"
      />
      <path
        d="M30.4333 3.04008H38.4611C42.0534 3.04008 44.4205 4.97266 44.4205 7.74848C44.4205 9.70782 43.3589 11.069 41.6992 11.6672C43.9036 12.2932 45.2102 13.9261 45.2102 16.2664C45.2102 19.4499 42.8421 21.5462 38.7329 21.5462H30.4322V3.04115L30.4333 3.04008ZM37.863 10.1701C38.9791 10.1701 39.5772 9.48952 39.5772 8.53714C39.5772 7.63933 38.9512 6.9855 37.8351 6.9855H35.6853V10.169H37.863V10.1701ZM38.0534 17.5184C39.4146 17.5184 40.0673 16.7565 40.0673 15.6682C40.0673 14.5799 39.4146 13.818 38.0812 13.818H35.6864V17.5195H38.0545L38.0534 17.5184Z"
        fill="currentColor"
      />
      <path
        d="M46.3306 17.3547C46.3306 14.7148 48.1808 12.9192 50.8486 12.9192C52.1819 12.9192 53.2702 13.3001 54.0053 14.0075V13.7624C54.0053 12.2654 52.8892 11.6939 51.42 11.6939C50.3039 11.6939 48.9984 12.0481 47.909 12.565V8.78223C49.4328 8.31995 51.1749 8.02033 52.8079 8.02033C56.2097 8.02033 59.176 9.48956 59.176 13.9797V21.5452H54.2504V20.3745C53.5976 21.2456 52.4815 21.7624 51.0123 21.7624C48.2365 21.7624 46.3317 19.9668 46.3317 17.3537L46.3306 17.3547ZM52.8079 18.6881C53.3526 18.6881 53.7603 18.5243 54.0053 18.2258V16.2664C53.7335 15.9122 53.298 15.7218 52.8079 15.7218C51.9101 15.7218 51.2841 16.3478 51.2841 17.2188C51.2841 18.0899 51.9101 18.6881 52.8079 18.6881Z"
        fill="currentColor"
      />
      <path
        d="M63.6437 2.06101C65.2221 2.06101 66.365 3.14929 66.365 4.6731C66.365 6.19691 65.2221 7.28519 63.6437 7.28519C62.0654 7.28519 60.9225 6.19691 60.9225 4.6731C60.9225 3.14929 62.0654 2.06101 63.6437 2.06101ZM61.0852 8.31997H66.2291V21.5463H61.0852V8.31997Z"
        fill="currentColor"
      />
      <path d="M68.305 2.4965H73.4757V21.5463H68.305V2.4965Z" fill="currentColor" />
      <path
        d="M74.9748 17.3547C74.9748 14.7148 76.825 12.9192 79.4928 12.9192C80.8261 12.9192 81.9144 13.3001 82.6495 14.0075V13.7624C82.6495 12.2654 81.5334 11.6939 80.0642 11.6939C78.9481 11.6939 77.6426 12.0481 76.5532 12.565V8.78223C78.077 8.31995 79.8192 8.02033 81.4521 8.02033C84.8539 8.02033 87.8202 9.48956 87.8202 13.9797V21.5452H82.8946V20.3745C82.2418 21.2456 81.1257 21.7624 79.6565 21.7624C76.8807 21.7624 74.9759 19.9668 74.9759 17.3537L74.9748 17.3547ZM81.4521 18.6881C81.9968 18.6881 82.4045 18.5243 82.6495 18.2258V16.2664C82.3777 15.9122 81.9422 15.7218 81.4521 15.7218C80.5543 15.7218 79.9283 16.3478 79.9283 17.2188C79.9283 18.0899 80.5543 18.6881 81.4521 18.6881Z"
        fill="currentColor"
      />
      <path
        d="M89.1407 19.1782C89.1407 17.6265 90.3114 16.5382 91.9433 16.5382C93.5752 16.5382 94.6923 17.6265 94.6923 19.1782C94.6923 20.7298 93.5495 21.8448 91.9433 21.8448C90.3371 21.8448 89.1407 20.7287 89.1407 19.1782Z"
        fill="currentColor"
      />
      <path
        d="M105.302 8.31995H110.064V9.57196C110.907 8.565 112.133 8.02033 113.547 8.02033C114.962 8.02033 116.187 8.7009 116.868 9.95291C117.739 8.7009 119.018 8.02033 120.624 8.02033C123.182 8.02033 124.788 10.061 124.788 13.4906V21.5463H119.617V13.9807C119.617 12.8646 119.317 12.2932 118.691 12.2932C117.956 12.2932 117.548 12.8914 117.548 13.9807V21.5463H112.541V13.9807C112.541 12.8646 112.242 12.2932 111.616 12.2932C110.881 12.2932 110.473 12.8914 110.473 13.9807V21.5463H105.302V8.31995Z"
        fill="currentColor"
      />
      <path
        d="M103.783 6.67627C103.35 6.50505 102.558 6.1958 101.865 6.42908C101.39 6.58852 101.032 7.06686 101.024 7.37825V8.31993H103.782V12.3766H101.695V21.5463H96.5276V12.3766H94.5008L94.504 8.31993H96.5276C96.5436 6.80789 96.3435 5.29264 97.2188 3.97322C98.4783 2.07381 101.847 1.99141 103.782 2.81003V6.67625H103.783Z"
        fill="currentColor"
      />
    </svg>
  );
}
